export enum AssetGroupType {
  AURORA = 'aurora',
  SPINE_MULTI_MEASUREMENT = 'spine_multi_measurement'
}
